module.exports = '<svg width="38" height="32" viewBox="0 0 38 32"><path d="M1.6 19.201h25.546l-7.494 7.743a1.669 1.669 0 0 0 0 2.288l2.189 2.294c.602.63 1.581.63 2.189 0l13.919-14.418a1.683 1.683 0 0 0 0-2.294L24.12.479a1.493 1.493 0 0 0-2.189 0L19.742 2.77a1.673 1.673 0 0 0 0 2.291l7.49 7.74H1.599c-.883 0-1.6.714-1.6 1.6v3.2c0 .88.717 1.6 1.6 1.6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-4.js
// module id = 1380
// module chunks = 14